<template>
    <div>
        <Header title="课程信息" memo="管理机构开办课程信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }" v-has="'UnitAdmin'">
                    添加
                </a-button>
                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" v-has="'UnitAdmin'" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="课程名称" @pressEnter="execQuery">
                            <a-icon slot="prefix" type="book" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column data-index="name" ellipsis width="350px">
                <span slot="title">课程名称</span>
                <template slot-scope="text, record">
                    {{ record.name }}
                </template>
            </a-table-column>
            <a-table-column data-index="type" ellipsis>
                <span slot="title">课程信息</span>
                <template slot-scope="text, record">
                    <a-tag color="#108ee9">
                        {{ record.type | fmtCourseType }}
                    </a-tag>
                    <a-tag color="#87d068">
                        {{ record.level }}
                    </a-tag>
                    <a-tag color="#CCCC66" v-if="!record.show">
                        网站隐藏
                    </a-tag>
                    <a-tag color="#FF66CC" v-if="record.rmd">
                        精品推荐
                    </a-tag>
                </template>
            </a-table-column>

            <a-table-column key="action" fixed width="300px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="eye" @click="showView(record)">
                        详情
                    </a-button>
                    <a-popconfirm v-has="'UnitAdmin'" :title="'是否删除课程[' + record.name + ']，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                        <a-button type="link" icon="delete">
                            删除
                        </a-button>
                    </a-popconfirm>
                    <a-button type="link" icon="edit" @click="showEditForm(record)" v-has="'UnitAdmin'">
                        编辑
                    </a-button>
                    <a-button type="link" v-if="!record.rmd" icon="star" @click="execRmd(record, true)" v-has="'PlatAdmin'">
                        设置精品
                    </a-button>
                    <a-button type="link" v-if="record.rmd" icon="star" @click="execRmd(record, false)" v-has="'PlatAdmin'">
                        取消精品
                    </a-button>
                    <a-button type="link" v-if="!record.show" icon="eye" @click="execShow(record, true)" v-has="'PlatAdmin'">
                        网站显示
                    </a-button>
                    <a-button type="link" v-if="record.show" icon="eye-invisible" @click="execShow(record, false)" v-has="'PlatAdmin'">
                        网站隐藏
                    </a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <FormComp title="编辑课程" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>

        <ViewComp title="课程详情" :item="now" :show.sync="view" v-if="view"></ViewComp>
    </div>
</template>

<script>
import FormComp from './FormComp'
import ViewComp from './ViewComp'

export default {
    name: 'UnitCourse',
    components: {
        FormComp,
        ViewComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            form: false,
            now: {}
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云信网', '课程信息'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            this.$http
                .get('/crs/train/course/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/crs/train/course/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doSetRmd(id, flag) {
            this.$http
                .post('/crs/train/course/rmd', {
                    id: id,
                    rmd: flag
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('设置成功')
                        this.doLoad()
                    }
                })
        },
        doSetShow(id, flag) {
            this.$http
                .post('/crs/train/course/show', {
                    id: id,
                    show: flag
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('设置成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}
            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },
        showView(item) {
            this.now = item
            this.view = true
        },
        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的课程')
                return
            }
            this.$confirm({
                title: '是否删除以下课程？删除后无法恢复。',
                content: '课程：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        },
        execRmd(item, flag) {
            this.$confirm({
                title: '是否' + (flag ? '设置为' : '取消设置') + '精品课程？',
                content: '课程：[' + item.name + ']',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doSetRmd(item.id, flag)
                }
            })
        },
        execShow(item, flag) {
            this.$confirm({
                title: '是否在网站【' + (flag ? '显示' : '隐藏') + '】课程？',
                content: '课程：[' + item.name + ']',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doSetShow(item.id, flag)
                }
            })
        }
    }
}
</script>
